import logo from "../images/explogo.png";
import logo2 from "../images/explogo@2x.png";
import { Link, useLocation } from "react-router-dom";
import { getPromoPrefix } from "../utils/promoPath";


const navLinks = [
  { label: "Home", path: "/" },
  { label: "FAQs", path: "/faq" },
  { label: "State Recognition", path: "/state-recognition" },
  { label: "Contact Us", path: "/contact-us" },
  { label: "Terms & Conditions", path: "/terms-conditions" },
  { label: "Privacy Policy", path: "/privacy-policy" },
];
 
const Footer = () => {
  const { pathname } = useLocation();
  const homePath = getPromoPrefix(pathname) || "/";
  const currentYear = new Date().getFullYear();

  return (
    <footer className="max-w-7xl mx-auto footer bg-white border-t border-gray-200 py-6">
      <div className="hidden lg:flex container mx-auto px-10 items-center justify-between gap-4">
        <div className="flex items-center gap-2 flex-shrink-0">
          <Link to={homePath} className="flex flex-shrink-0">
            <img
              width={150}
              height={49}
              src={logo}
              srcSet={`${logo} 1x, ${logo2} 2x`}
              alt="Expedite Concealed Carry"
              style={{ width: "150px", height: "auto" }}
            />
          </Link>
          <p className="font-acumin text-[0.72rem] text-gray-600 whitespace-nowrap">
            COPYRIGHT (c) {currentYear} Expedite Concealed Carry. All Rights Reserved.
          </p>
        </div>
        <nav className="flex items-center flex-wrap justify-end gap-x-4 gap-y-1">
          {navLinks.map((link) => (
            <Link
              key={link}
              to={link.path}
              className="font-acumin text-[0.72rem] text-gray-600 hover:text-gray-900 transition-colors whitespace-nowrap"
              target="_blank"
              >
              {link.label}
            </Link>
          ))}
        </nav>
      </div>

      <div className="flex lg:hidden flex-col items-center gap-4 px-6 w-full max-w-sm mx-auto">
        <Link to={homePath} className="flex flex-shrink-0">
          <img
            width={190}
            height={62}
            src={logo}
            srcSet={`${logo} 1x, ${logo2} 2x`}
            alt="Expedite Concealed Carry"
            style={{ width: "190px", height: "auto" }}
          />
        </Link>

        <nav className="grid grid-cols-3 mob-nav gap-x-6 gap-y-2 text-center w-full">
          {navLinks.map((link) => (
            <Link
              key={link}
              to={link.path}
              className="font-acumin text-[0.72rem] text-gray-600 hover:text-gray-900 transition-colors"
              target="_blank"
           >
              {link.label}
            </Link>
          ))}
        </nav>

        <p className="font-acumin text-[0.65rem] text-gray-500 text-center">
          COPYRIGHT (c) {currentYear} Expedite Concealed Carry.
          <br />
          All Rights Reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
